const config = {
  app: {
    prefix: "afcd",
    title: "ARM Field Campaigns",
    host: "https://adc.arm.gov/afcd",
  },
  auth: {
    cas: "https://armdev-sso.ornl.gov/arm",
    authService: "https://adc.arm.gov/Auth/",
    serviceName: "https://adc.arm.gov/afcd",
    logout: "https://armdev-sso.ornl.gov/arm/logout",
    sessionExpirationMinutes: 30,
    sessionWarningMinutes: 25,
  },
  graphql: {
    host: "https://adc.arm.gov/graphql",
  },
  fieldCampaignDashboardFileApi: {
    host: "https://adc.arm.gov/Auth/field-catalog-file-api", //TODO: Change this when Prod API deployment is ready
  },
  google: {
    recaptchaKey: "6LdzDTYUAAAAAL05blc17MfL5erA19qPaRfKngtH",
  },
  notification: {
    baseURL: "https://adc.arm.gov/NotificationService",
    emailRegex: /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/,
  },
  sso: {
    logout: "https://sso.arm.gov/arm/logout",
  },
  profile: {
    baseUrl: "https://adc.arm.gov/profile/preference",
    userRegUrl: "https://adc.arm.gov/armuserreg",
  },
  plots: {
    baseUrl: "https://plot.dmf.arm.gov/PLOTS/",
    videoThumbBaseUrl: "https://plot.dmf.arm.gov/plotbrowser/thumbs/",
  },
  session: {
    authService: true,
    graphQL: true,
    sessionExpirationMinutes: 30,
    sessionWarningMinutes: 25,
  },
  maintenance: {
    maintenanceToolUrl: "https://adc.arm.gov/ARMMaintenanceTools/#",
    pmApiUrl: "https://adc.arm.gov/Auth/arm-pmreport-api",
    cmApiUrl: "https://adc.arm.gov/Auth/arm-cmreport-api",
    pmApiSearchUrl: "https://adc.arm.gov/Auth/arm-pmreport-api/report/search/spec",
    cmApiSearchUrl: "https://adc.arm.gov/Auth/arm-cmreport-api/custom/search/spec",
  },
  maintenanceCheck: {
    url: "https://maintenance-check-api.svcs.arm.gov/arm",
  },
}

export default config
